import React, { ReactElement, useEffect, useRef, FC } from 'react'
import './style.scss'
interface Props {
  maxValue: number
  value: number
  color: string
}
export const TrendBar: FC<Props> = ({
  value,
  maxValue,
  color
}): ReactElement => {
  return (
    <div className='trend-bar'>
      <div
        style={{
          width: Math.min(50, 50 + (value / (maxValue * 2)) * 100) + '%'
        }}
      />
      <div
        className='trend'
        style={{
          backgroundColor: color,
          width: (Math.abs(value) / (maxValue * 2)) * 100 + '%',
          borderLeftStyle: value >= 0 ? 'solid' : 'none',
          borderRightStyle: value < 0 ? 'solid' : 'none'
        }}
      />
    </div>
  )
}
